import { DeepPartial } from '@apollo/client/utilities'
import { TrainingsTrainingRequestApprovableMetadataFragment } from 'generated/resources/graphql'

export const getTrainingsTrainingRequestMetadata = (
  data: DeepPartial<TrainingsTrainingRequestApprovableMetadataFragment>
) => {
  return [data.trainingName].filter(Boolean)
}
